import { sanitizeError } from 'utils/sanitizeError';

export const INVALIDATED_TOKEN_ERROR_CODE = 401;

export const LEGACY_INVALIDATED_TOKEN_ERROR_CODE = 423;

/**
 * Returns a boolean if the response is throwing an
 * error code for an invalidated token
 * @param  {promise} response
 * @return {boolean}
 */
export const checkIfInvalidatedTokenError = (response) => {
    const errorCodeList = [INVALIDATED_TOKEN_ERROR_CODE, LEGACY_INVALIDATED_TOKEN_ERROR_CODE];
    const errorCode = response?.status || response?.code || response?.meta?.code;
    const isInvalidatedTokenError = response && errorCodeList.includes(errorCode);
    return isInvalidatedTokenError;
};

/**
 * Checks if the response is throwing an error for the user's token
 * being invalidated. Shows the InvalidatedTokenModal if it exists.
 * @param  {promise} response
 * @return {error|promise}
 */
const catchInvalidatedTokenError = (response) => {
    if (checkIfInvalidatedTokenError(response)) {
        if (window.SPLASH && window.SPLASH.openInvalidatedTokenModal) {
            window.SPLASH.openInvalidatedTokenModal();
        }

        throw sanitizeError(response);
    }

    return response;
};

export default catchInvalidatedTokenError;
